module.exports = __webpack_public_path__ + "img/retry-icon.15d79135.svg";